export default [
    {name: 'Ana Sayfa', icon: 'fa fa-home text-blue', path: '/'},
    {name: 'Kasa Raporu', icon: 'fas fa-lira-sign text-orange', path: '/kasa-raporu'},
    {name: 'Ödeme Şekilleri Raporu', icon: 'fas fa-dollar-sign text-yellow', path: '/odeme-sekilleri-raporu'},
    {name: 'Satış Adetleri Raporu', icon: 'fas fa-shopping-cart text-info', path: '/satis-adetleri-raporu'},
    {name: 'İptal Edilenler Raporu', icon: 'fas fa-ban text-red', path: '/iptal-edilenler-raporu'},
    {name: 'Masa Doluluk Oranı', icon: 'fas fa-table text-pink', path: '/masa-doluluk-orani'},
    {name: 'Stok Raporu', icon: 'fas fa-chart-bar text-red', path: '/stok-raporu'},
    {name: 'Çıkış', icon: 'fas fa-sign-out-alt text-red', path: '/cikis'}
]